import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const propTypes = {
    button: PropTypes.node,
    className: PropTypes.string,
};

const defaultProps = {
    button: false,
    className: null,
};

const EmptyResults = ({ button, className }) => (
    <section className={className}>
        <div className="container-fluid text-center bg-dark text-light p-5">
            <h1 className="display-4">
                <FormattedMessage defaultMessage="No results" description="Box title" />
            </h1>
            <p className="lead mt-4 mb-4">
                <FormattedMessage
                    defaultMessage="Please make another search."
                    description="Box description"
                />
            </p>
            {button !== null ? <p className="lead pt-4">{button}</p> : null}
        </div>
    </section>
);

EmptyResults.propTypes = propTypes;
EmptyResults.defaultProps = defaultProps;

export default EmptyResults;
